import React, { useState } from 'react';
import { AuthProvider, useAuth } from './components/Auth/AuthContext';
import LoginPage from './components/Auth/LoginPage';
import Layout from './components/Layout/Layout';
import QuoteEditor from './components/Quotes/QuoteEditor';
import QuotesListPage from './components/Quotes/QuotesListPage';
import CustomersPage from './components/Customers/CustomersPage';
import CompanyPage from './components/Settings/CompanyPage';
import TeamPage from './components/Settings/TeamPage';
import ProfilePage from './components/Settings/ProfilePage';
import SuperAdminLogin from './components/SuperAdmin/SuperAdminLogin';
import CustomerPortal from './components/Portal/CustomerPortal';
import LandingPage from './components/Landing/LandingPage';
import SuperAdminDashboard from './components/SuperAdmin/SuperAdminDashboard';

// Kolla om vi är på /superadmin-sidan
const isSuperAdminPath = window.location.pathname.startsWith('/superadmin');
const isPortalPath = window.location.pathname.startsWith('/portal');

function SuperAdminApp() {
  const [saEmail, setSaEmail] = useState(() => {
    const token = localStorage.getItem('sa_token');
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp * 1000 < Date.now()) { localStorage.removeItem('sa_token'); return null; }
      return payload.email;
    } catch { return null; }
  });

  if (!saEmail) return <SuperAdminLogin onLogin={setSaEmail} />;
  return <SuperAdminDashboard email={saEmail} onLogout={() => setSaEmail(null)} />;
}

function AppInner() {
  const { user, loading } = useAuth();
  const [view, setView] = useState('new-quote');
  const [editingQuoteId, setEditingQuoteId] = useState(null);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-500 font-bold">Laddar...</p>
        </div>
      </div>
    );
  }

  if (!user) return <LoginPage />;

  const openQuote = (quote) => { setEditingQuoteId(quote.id); setView('edit-quote'); };
  const startNewQuote = () => { setEditingQuoteId(null); setView('new-quote'); };

  const renderView = () => {
    switch (view) {
      case 'new-quote':
      case 'edit-quote':
        return <QuoteEditor key={editingQuoteId || 'new'} quoteId={editingQuoteId} onBack={() => setView('quotes')} onSaved={() => {}} />;
      case 'quotes':
        return <QuotesListPage onOpenQuote={openQuote} onNewQuote={startNewQuote} />;
      case 'customers':
        return <CustomersPage />;
      case 'company':
        return <CompanyPage />;
      case 'team':
        return <TeamPage />;
      case 'profile':
        return <ProfilePage />;
      default:
        return null;
    }
  };

  return (
    <Layout view={view} setView={(v) => { if (v === 'new-quote') startNewQuote(); else setView(v); }}>
      {renderView()}
    </Layout>
  );
}

export default function App() {
  if (isSuperAdminPath) return <SuperAdminApp />;
  if (isPortalPath) return <CustomerPortal />;
  if (window.location.pathname === '/' || window.location.pathname === '') return <LandingPage />;
  return <AuthProvider><AppInner /></AuthProvider>;
}
